// extracted by mini-css-extract-plugin
export default {"flexContainer":"CustomSelect_flexContainer__iSKuI","colorTab":"CustomSelect_colorTab__akHez"};